import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { urls } = app?.backend;

export class AdvancedCommandService {

    static getAll = async ({
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'AdvancedCommandService - getAll';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.advancedCommands}/`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static getById = async ({
        id = '',
        token = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'AdvancedCommandService - getById';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.advancedCommands}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.get({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static deleteById = async ({
        id = '',
        token = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'AdvancedCommandService - deleteById';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.advancedCommands}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.delete({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static createAdvancedCommand = async ({
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'AdvancedCommandService - createAdvancedCommand';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.advancedCommands}/`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static update = async ({
        id = '',
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'AdvancedCommandService - update';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.advancedCommands}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
}
